module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('WebTemplate', {
    attrs: {
      "pagetitle": "搜索推广",
      "tip": "搜索推广报告为您展示360搜索推广的推广及效果数据，帮助您及时了解您网站在360上的搜索推广状态，依据效果数据优化账户",
      "timeType": "7a",
      "currentTab": _vm.currentTab,
      "total": _vm.total,
      "pg": _vm.pg,
      "ps": _vm.ps,
      "tablist": _vm.tablist,
      "customColumns": _vm.customColumns,
      "tableDataList": _vm.tableDataList,
      "hasCheckBox": _vm.hasCheckBox,
      "checkboxLength": _vm.checkboxLength,
      "sum": _vm.sum,
      "order": _vm.order,
      "legend": _vm.legend,
      "yAxis": _vm.yAxis,
      "chartXAxis": _vm.chartXAxis,
      "chartSeries": _vm.chartSeries,
      "customIndice": _vm.customIndice,
      "twoIndiceShow": _vm.twoIndiceShow,
      "twoIndice": _vm.twoIndice
    },
    on: {
      "indiceChange": _vm.indiceChange,
      "tableUpdate": _vm.getTableData,
      "tablesorter": _vm.tablesorter
    }
  }, [(_vm.dianjingIDList.length > 0) ? _c('span', {
    staticClass: "floatr",
    slot: "accountSelect"
  }, [_c('label', [_vm._v("账号切换：")]), _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dianjingID),
      expression: "dianjingID"
    }],
    attrs: {
      "options": _vm.dianjingIDList
    },
    domProps: {
      "value": (_vm.dianjingID)
    },
    on: {
      "input": [function($event) {
        _vm.dianjingID = $event
      }, _vm.resetCompared]
    }
  })], 1) : _vm._e(), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mvDemain),
      expression: "mvDemain"
    }],
    staticClass: "mv-tips",
    slot: "tableTitleTip"
  }, [_vm._v("为什么看不到流量及转化数据"), _c('v-tooltip', {
    attrs: {
      "tip": '由于您网站添加的代码为聚合分析代码，无法获取搜索推广对应的流量数据，若您想查看该部分数据，建议为您的网站重新添加360分析代码。',
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1), _c('ul', {
    staticClass: "tab",
    slot: "tabview"
  }, _vm._l((_vm.tabViews), function(item) {
    return _c('li', {
      staticClass: "tab-item"
    }, [_c('div', {
      staticClass: "tabview-btn",
      class: {
        active: _vm.currentView === item.comp
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeViewTo(item.comp)
        }
      }
    }, [_vm._v(_vm._s(item.title))])])
  })), _c('div', {
    staticClass: "nav-tabs",
    slot: "nav-tabs"
  }, [_c('TabContent', {
    attrs: {
      "title": "主维度：",
      "tablist": _vm.tablist,
      "update": _vm.updateTab,
      "currentTab": _vm.currentTab
    }
  }, [_c('div', {
    staticClass: "right-tab",
    slot: "extentTab"
  }, [(_vm.total > 0) ? _c('DownloadBtn', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "reportApi": _vm.reportApi,
      "params": _vm.query,
      "pagetitle": _vm.reportName,
      "subtitle": ""
    }
  }) : _vm._e(), _c('CustomIndice', {
    attrs: {
      "defaults": _vm.defaultCustomIndices,
      "hasSystemIndice": true,
      "hasSpreadIndice": true,
      "fluxExtend": _vm.fluxExtend
    },
    on: {
      "change": _vm.onCustomIndiceChange
    }
  })], 1), _c('div', {
    slot: "common"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sdimOptionShow),
      expression: "sdimOptionShow"
    }],
    staticClass: "plan-nav"
  }, [_vm._v("选择二级维度："), _c('v-radio-group', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sdim),
      expression: "sdim"
    }],
    attrs: {
      "name": "secondaryDim",
      "options": _vm.sdimOptions
    },
    domProps: {
      "value": (_vm.sdim)
    },
    on: {
      "input": function($event) {
        _vm.sdim = $event
      }
    },
    nativeOn: {
      "change": function($event) {
        _vm.sdimChange($event)
      }
    }
  })], 1), _c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")]), (_vm.planlistShow) ? _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.planselected),
      expression: "planselected"
    }],
    attrs: {
      "options": _vm.planlistOptions
    },
    domProps: {
      "value": (_vm.planselected)
    },
    on: {
      "input": [function($event) {
        _vm.planselected = $event
      }, _vm.getGroupList]
    }
  }) : _vm._e(), (_vm.grouplistShow && _vm.planselected) ? _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.groupselected),
      expression: "groupselected"
    }],
    attrs: {
      "options": _vm.grouplistOptions
    },
    domProps: {
      "value": (_vm.groupselected)
    },
    on: {
      "input": [function($event) {
        _vm.groupselected = $event
      }, function($event) {
        _vm.getTableData(1)
      }]
    }
  }) : _vm._e(), _c('Search', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchBoxShow),
      expression: "searchBoxShow"
    }],
    attrs: {
      "placeholder": _vm.placeHolder,
      "defaultValue": _vm.keyword
    },
    on: {
      "doSearch": _vm.doSearch
    }
  })], 1)])])], 1), (_vm.transTypeShow) ? _c('v-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transelected),
      expression: "transelected"
    }],
    attrs: {
      "options": _vm.transList
    },
    domProps: {
      "value": (_vm.transelected)
    },
    on: {
      "input": [function($event) {
        _vm.transelected = $event
      }, function($event) {
        _vm.getTableData()
      }]
    },
    slot: "custom"
  }) : _vm._e(), _c('v-tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentView != 'promotion'),
      expression: "currentView != 'promotion'"
    }],
    attrs: {
      "tip": '搜索词报告展现量统计过滤了展现极低且无点击数据，请使用此报告主要进行触发分析，实际数据以效果分析报告为准。',
      "pos": "right"
    },
    slot: "adpv-th"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-019821b9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-019821b9!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/promotion.vue
// module id = 704
// module chunks = 0